import React, { createContext, useState, useContext } from 'react';
import fr from '../locales/fr.json';
import en from '../locales/en.json';

const translations = { fr, en };

const TranslationContext = createContext();

export const TranslationProvider = ({ children }) => {
  const [language, setLanguage] = useState('fr');

  const t = (key, fallback) => {
    const currentTranslations = translations[language];

    // Prioritize direct match for flat keys that might conflict with nested structures (e.g., 'cta.cv')
    if (currentTranslations && typeof currentTranslations[key] === 'string') {
      return currentTranslations[key];
    }

    // Handle nested keys (e.g., 'portfolio.title' or 'cta.cv' if it's inside a 'cta' object)
    const keys = key.split('.');
    let result = currentTranslations;
    for (const k of keys) {
      if (result && typeof result === 'object' && k in result) {
        result = result[k];
      } else {
        // If the path breaks, it means it's not a valid nested key.
        // Return the original key as a fallback.
        return fallback ?? key;
      }
    }

    // Ensure we don't return an object (e.g., for a partial key like 'portfolio')
    return typeof result === 'string' ? result : (fallback ?? key);
  };

  return (
    <TranslationContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </TranslationContext.Provider>
  );
};

export const useTranslation = () => {
  return useContext(TranslationContext);
};
